import { Component } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';
import { TaggingService } from '../../../tag-manager';
import { DirectFooterConfigurationService } from '../../services/direct-footer-configuration.service';

@Component({
  selector: 'boi-logout',
  templateUrl: './logout.page.html'
})
export class LogoutPage {
  public readonly referenceDataLabels = ReferenceDataLabels;
  constructor(
    private readonly taggingService: TaggingService,
    private readonly footerConfigurationService: DirectFooterConfigurationService
  ) {
    this.footerConfigurationService.setDefaultFooter();
    this.taggingService.resetDataLayer();
    this.taggingService.execute();
  }
}
